import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getData } from "../../../utils/fetch";

export const getDataJobOffering = createAsyncThunk(
  "jobOffering/getData",
  async (args, { rejectWithValue }) => {
    try {
      const result = await getData(`/cms/job-offers`);
      return result.data.data;
    } catch (error) {
      rejectWithValue(error.response.data);
    }
  }
);

const jobOfferingSlice = createSlice({
  name: "job-offering",
  initialState: {
    data: [],
    page: 1,
    limit: 10,
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDataJobOffering.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(getDataJobOffering.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(getDataJobOffering.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default jobOfferingSlice.reducer;
